<template>
  <v-card>
    <ODialogBar no-close title="Status e Relays"> </ODialogBar>

    <v-card-text class="pa-3 d-flex flex-wrap justify-stretch">
      <OCapCont class="w-200 pa-3" label="Pausada?">
        <v-btn block :color="pauseButton.color" @click="changeFlag('isPaused')">
          {{ pauseButton.text }}
        </v-btn>
      </OCapCont>

      <OCapCont class="w-200 pa-3" label="Ignorada?">
        <v-btn
          block
          :color="ignoreButton.color"
          @click="changeFlag('isIgnored')"
        >
          {{ ignoreButton.text }}
        </v-btn>
      </OCapCont>

      <SelectRelaysDialog ref="dialog" />

      <OCapCont class="grow-1 pa-3" label="Relays">
        <div class="d-flex align-center">
          <OSpans class="tag-list" eachClass="tag" :pieces="relayOrgNames" />
          <v-btn icon @click="editRelays">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </OCapCont>
    </v-card-text>
  </v-card>
</template>

<script>
import { Org } from '@/models'
import SelectRelaysDialog from './SelectRelaysDialog.vue'

export default {
  components: { SelectRelaysDialog },
  props: {
    org: { required: true }
  },
  data() {
    return { allOrgs: [] }
  },
  mounted() {
    this.fetchOrgsForRelay()
  },
  computed: {
    pauseButton() {
      if (this.org.isPaused) {
        return { color: 'amber', text: 'Pausada' }
      } else {
        return { color: null, text: 'Não pausada' }
      }
    },
    ignoreButton() {
      if (this.org.isIgnored) {
        return { color: 'error', text: 'Ignorada' }
      } else {
        return { color: null, text: 'Não ignorada' }
      }
    },
    relayOrgNames() {
      let ids = this.org.extraInfo && this.org.extraInfo.relayOrgIds
      if (ids == null) return '─'

      return ids.map((id) => {
        let org = this.allOrgs.find((x) => x.id == id)
        return org ? org.name : `??${id}??`
      })
    }
  },
  methods: {
    async fetchOrgsForRelay() {
      this.allOrgs = await Org.findAll({ mini: true })
    },
    async editRelays() {
      let res = await this.$refs.dialog.open(this.org.id)
      if (res === true) {
        // this.reload()
        this.$emit('reload')
      }
    },

    async changeFlag(flagName) {
      let oldV = this.org[flagName]
      let newV = !oldV

      let message = `
        Tem certeza que deseja alterar a flag
        <code>${flagName}</code> para o valor
        <code>${newV}</code>?`

      let res = await this.$confirm({
        icon: 'od-warning',
        message
      })

      if (res) {
        this.$rootLoading(async () => {
          let body = {}
          body[flagName] = newV
          await Org.patch(this.org.id, body)
          this.$snack('Salvo com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
